// @flow

import type {
  FertilizerOperationsById,
} from 'hfty-operator-fertilizers/types'

// Constants
import {
  OPERATIONS_TREE,
  OPERATIONS_BRANCH,
} from 'fc-model-fertilizers'

import traverse from 'fc-utils/traverse'

type FertilizerOperationsSelector = (state: Object) => FertilizerOperationsById

export default (traverse([OPERATIONS_TREE, OPERATIONS_BRANCH]): FertilizerOperationsSelector)
